import { TEST_ID_WATCHLIST } from "e2e/testId";
import React, { memo } from "react";

import { Badge, BadgeText } from "@/components/atoms/Badge";

/**
 *
 */
interface IProps {
  colorClass: {
    background: string;
    border: string;
    text: string;
  };
  formattedValue: string;
}

/**
 * Badge surface style.
 * design-system: dynamic-style waiver — data-driven value (caller-provided colors)
 * @param colorClass - Background/border/text color set
 */
const badgeStyle = (colorClass: IProps["colorClass"]) => ({
  backgroundColor: colorClass.background,
  borderColor: colorClass.border,
});

/**
 * Badge text color style.
 * design-system: dynamic-style waiver — data-driven value (caller-provided color)
 * @param colorClass - Background/border/text color set
 */
const badgeTextStyle = (colorClass: IProps["colorClass"]) => ({
  color: colorClass.text,
});

/**
 * Renders a badge with custom colors and formatted value
 * @param root0 - Component props
 * @param root0.colorClass - Object containing background, border, and text colors
 * @param root0.formattedValue - The formatted value to display in the badge
 */
const BadgeView = ({ colorClass, formattedValue }: IProps) => (
  <Badge
    size="lg"
    variant="solid"
    className="w-14 items-center justify-center border px-0 "
    // eslint-disable-next-line no-restricted-syntax -- data-driven caller-provided badge background/border colors; Badge is a bare re-export atom (no UNSAFE_style forwarding)
    style={badgeStyle(colorClass)}
  >
    <BadgeText
      testID={TEST_ID_WATCHLIST.PLAYER_BADGE_VALUE}
      // eslint-disable-next-line no-restricted-syntax -- data-driven caller-provided badge text color; BadgeText is a bare re-export atom (no UNSAFE_style forwarding)
      style={badgeTextStyle(colorClass)}
    >
      {formattedValue}
    </BadgeText>
  </Badge>
);

BadgeView.displayName = "BadgeView";

export default memo(BadgeView);
